import { View } from "@react-pdf/renderer";
import { CreateBillDto } from "../../model/bill/dto/CreateBillDto";

import { TableHeader } from "../TableHeader";
import { TableRow } from "../TableRow";
import { UpdateBillDto } from "../../model/bill/dto/UpdateBillDto";
import { Bill } from "../../model/bill/types/Bill";

type PDFTableProps = {
  dto: CreateBillDto | UpdateBillDto | Bill;
};

export const PDFTable: React.FC<PDFTableProps> = ({ dto }) => {
  const { billDetails } = dto;

  return (
    <View>
      <TableHeader />
      {billDetails?.map((item, index) => {
        const calculatedAmount =
          Number(item.qty) * Number(item.unitPrice)
            ? String(
                Number((Number(item.qty) * Number(item.unitPrice)).toFixed(2))
              )
            : "";

        const itemWithAmount = {
          ...item,
          amount: calculatedAmount,
        };

        return <TableRow key={item._id} data={itemWithAmount} index={index} />;
      })}
    </View>
  );
};
